import { render, staticRenderFns } from "./RemuneracaoSuporteAdminUsuariosRightNavBar.vue?vue&type=template&id=2444dfa2"
import script from "./RemuneracaoSuporteAdminUsuariosRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoSuporteAdminUsuariosRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoSuporteAdminUsuariosRightNavBar.vue?vue&type=style&index=0&id=2444dfa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports